import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const BACKEND_URL = '';

const Promotion = () => {
  const [promotion, setPromotion] = useState({
    discount: '20% OFF',
    title: 'Back to School Sale!!',
    description: 'Join the sale event now and get a pair for a discount (or two) before they are all gone.',
    endDate: 'Monday September 30, 2024',
    image: null,
    use_custom_image: false
  });

  useEffect(() => {
    // Fetch promotion from API
    const fetchPromotion = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/promotion`);
        if (response.ok) {
          const data = await response.json();
          setPromotion({
            discount: data.discount,
            title: data.title,
            description: data.description,
            endDate: data.end_date,
            image: data.image,
            use_custom_image: data.use_custom_image || false
          });
        }
      } catch (error) {
        console.error('Error fetching promotion:', error);
      }
    };
    fetchPromotion();
  }, []);

  // If using custom image, show the uploaded promotional image
  if (promotion.use_custom_image && promotion.image) {
    return (
      <section className="py-8 bg-gray-100">
        <div className="container mx-auto px-4">
          <Link to="/contact" className="block max-w-5xl mx-auto">
            <img 
              src={promotion.image}
              alt={promotion.title || "Monthly Promotion"}
              className="w-full h-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
            />
          </Link>
        </div>
      </section>
    );
  }

  // Default text-based promotion
  return (
    <section className="py-20 bg-gradient-to-br from-red-600 to-red-700 text-white relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-block bg-white text-red-600 px-8 py-4 rounded-full text-4xl md:text-5xl font-bold mb-6 shadow-2xl transform hover:scale-105 transition-transform">
            {promotion.discount}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {promotion.title}
          </h2>
          <p className="text-lg md:text-xl mb-2 opacity-95">
            {promotion.description}
          </p>
          <p className="text-sm mb-8 opacity-90">
            Sale ends {promotion.endDate}
          </p>
          <Link 
            to="/contact"
            className="bg-white text-red-600 px-10 py-4 rounded-md hover:bg-gray-100 transition-all font-bold text-lg transform hover:scale-105 inline-block"
          >
            Visit Us Now & Save
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Promotion;
